import { useEffect, useMemo, useState } from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useGetFavoriteRecipeQuery } from '../../services/endpoints/content/recipe';
import { useGetChildrenLessonPlansQuery } from '../../services/endpoints/schedule/lesson';
import { GetQueryParams } from '../../types/api.type';
import { LessonPlan, Recipe } from '../../types/lessonPlan.type';
import LessonPlanCard from '../home/recipes/LessonPlanCard';
import RecipeCard from '../home/recipes/RecipeCard';

interface FavoritesProps {}

const Favorites: React.FC<FavoritesProps> = () => {
  const [recipes, setRecipes] = useState<Recipe[]>([]);
  const [recipeCount, setRecipeCount] = useState<number>(0);

  const [filtersRecipes] = useState<GetQueryParams>({
    data: { entries: 100 }
  });

  const { data: favoritesData } = useGetFavoriteRecipeQuery(filtersRecipes);
  const { data: courseLessonsData } = useGetChildrenLessonPlansQuery({
    data: {}
  });

  const myCourseLessonPlans = useMemo(() => {
    if (!courseLessonsData) return [];
    const seen = new Set<number>();
    const deduped: LessonPlan[] = [];
    courseLessonsData.forEach((lesson) => {
      lesson.lesson_plans?.forEach((lp) => {
        if (lp && !seen.has(lp.id)) {
          seen.add(lp.id);
          deduped.push(lp);
        }
      });
    });
    return deduped;
  }, [courseLessonsData]);

  useEffect(() => {
    if (favoritesData?.results) {
      setRecipes(favoritesData.results);
      setRecipeCount(favoritesData.count ?? 0);
    }
  }, [favoritesData]);

  return (
      <div className="container-fluid">
        <Tabs
            defaultActiveKey="Courses"
            id="my-recipes-tabs"
            className="mb-3"
        >
          <Tab eventKey="Courses" title="Courses">
            {myCourseLessonPlans.length === 0 ? (
                <p className="text-center text-muted my-5">
                  No recipes from your courses yet. They'll appear here as you register for sessions.
                </p>
            ) : (
                <>
                  <div className="search-results">
                <span>
                  Showing <strong>{myCourseLessonPlans.length}</strong> results
                </span>
                  </div>
                  <div className="recipes-grid">
                    <Row className="mb-4">
                      {myCourseLessonPlans.map((lp) => (
                          <Col
                              key={lp.id}
                              md={4}
                              className="mb-4"
                          >
                            <LessonPlanCard lessonPlan={lp} />
                          </Col>
                      ))}
                    </Row>
                  </div>
                </>
            )}
          </Tab>
          <Tab eventKey="Favorites" title="Favorites">
            {recipes.length === 0 ? (
                <p className="text-center text-muted my-5">
                  No favorites yet. Tap the heart icon on any recipe to save it here.
                </p>
            ) : (
                <>
                  <div className="search-results">
                <span>
                  Showing <strong>{recipeCount}</strong> results
                </span>
                  </div>
                  <div className="recipes-grid">
                    <Row className="mb-4">
                      {recipes.map((r) => (
                          <Col
                              key={r.id}
                              md={4}
                              className="mb-4"
                          >
                            <RecipeCard recipe={r} />
                          </Col>
                      ))}
                    </Row>
                  </div>
                </>
            )}
          </Tab>
        </Tabs>
      </div>
  );
};

export default Favorites;